<app-notification />
<ion-split-pane contentId="main-content" [disabled]="isMenuDisabled">
	<app-loading></app-loading>
	<ion-menu contentId="main-content" type="overlay" menuId="mainMenu">
		<ion-content>
			<ion-list id="inbox-list">
				<div class="logo-container">
					<div class="container-image-user">
						<app-icon class="icon" iconName="user" />
						<!-- TO DO - NO EXISTEN IMAGENES DE PERFIL-->
						<!-- <app-icon *ngIf="!isLoggedIn; else showImage" class="icon" iconName="user" />
						<ng-template #showImage>
							<img alt="img" src="assets/user.jpg" />
						</ng-template> -->
					</div>
					<label for="name">{{ userName || translations.guest }}</label>
					<span *ngIf="userEmail">{{ userEmail }}</span>
				</div>

				<div class="container-menu-actions" [ngClass]="{ 'authenticated-menu': isLoggedInSignal() }">
					<!-- Mostrar solo las páginas permitidas -->
					<div class="menu-sidebar">
						<div *ngFor="let p of appPages; let i = index" (click)="hideMenuSidebar()">
							<!-- Ocultar "My Profile" si no está logueado -->
							<div
								*ngIf="isLoggedInSignal() || p.title == 'Home'"
								class="nav-item"
								routerDirection="root"
								[routerLink]="navigateToUrl(p)"
								routerLinkActive="selected"
								[routerLinkActiveOptions]="{ exact: p.title === 'Home' }"
							>
								<app-icon [iconName]="p.icon" />
								<label for="nav-item-{{ i }}">
									{{ translations[p.titleKey || p.title] || p.title }}
								</label>
							</div>
						</div>
					</div>
				</div>

				<div class="container-logout">
					<!-- Mostrar "Invitado" si no está logueado -->
					<app-button
						*ngIf="!isLoggedInSignal()"
						[text]="attrLabelSignIn()"
						type="button-outline"
						icon="user-shield"
						class="button w-full"
						(buttonClicked)="openSignInModal()"
					/>

					<div class="menu-sidebar" *ngIf="isLoggedInSignal()">
						<div class="nav-item" (click)="closeSesion()">
							<app-icon iconName="logout" />
							<label>
								{{ translations.logOut }}
							</label>
						</div>
					</div>
				</div>
			</ion-list>
		</ion-content>
	</ion-menu>

	<ion-menu class="cartMenu" contentId="main-content" type="overlay" side="end" menuId="cartMenu">
		<app-shoppingcart />
	</ion-menu>
	
	<router-outlet id="main-content" />
</ion-split-pane>
